<template>
  <div class="collection">
    <div class="body-right-upload-list mach-width" v-loading='loading'>

      <div v-if="list && list.length">
        <div v-for="(s,idx) in list" :key="idx" class="body-right-upload-list-item position-relative flex cursor mach-width" :data-index="idx" @mouseover="mouseover" @mouseleave="mouseleave" @click="toDetail(s)">
          <div class="body-right-upload-list-item-img">
            <div class="img" :style="{backgroundImage: 'url('+ s.preview + ')'}" />
          </div>
          <div class="body-right-upload-list-item-info flex-1">
            <div class="body-right-upload-list-item-info-tit flex-row-align-center">
              <p class=" font-bold text-line-1 mach-width font-color-264480 font-size-18">{{ s.collectionName }}</p>
            </div>
            <div class="body-right-upload-list-item-info-desc flex-row-align-center">
              <p class="font-size-14 font-color-666 text-line-1">{{ s.description }}</p>
            </div>
            <div class="body-right-upload-list-item-info-mark flex-row-align-center flex-row-justify-space-between">
              <div :class="s.pictureNumber > 0 || s.videoNumber > 0 || s.audioNumber > 0 || s.pdfNumber > 0 || s.zipNumber > 0 ? 'status-success':''" class="body-right-upload-list-item-info-mark-item radius-clip-5 flex-center">
                <p v-if="s.pictureNumber > 0" class="font-size-12">{{ s.pictureNumber }}图片</p>
                <p v-if="s.videoNumber > 0" class="font-size-12">{{ s.videoNumber }}视频</p>
                <p v-if="s.audioNumber > 0" class="font-size-12">{{ s.audioNumber }}音频</p>
                <p v-if="s.pdfNumber > 0" class="font-size-12">{{ s.pdfNumber }}文稿</p>
                <p v-if="s.zipNumber > 0" class="font-size-12">{{ s.zipNumber }}文件</p>
              </div>
              <div v-if="mouseOverIndex==idx" class="body-right-upload-list-item-info-mark-del flex-center cursor" :data-index="idx" @click.stop="showdelapply">
                <p class="font-size-12 font-color-264480">取消收藏</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="empty mach-width font-size-16 flex-center">
        暂无内容
      </div>
    </div>
    <div v-if="totalPage>1" class="data-pagination mach-width flex-center">
      <el-pagination next-text="下一页" prev-text="上一页" background hide-on-single-page :current-page.sync="current" :page-size="10" layout="total, prev, pager, next" :total="total" @current-change="jumpPage" />
    </div>
    <!-- 分页器 -->
    <!-- <div v-if="list.length" class="data-pagination mach-width flex-center">
      <pagination
        v-if="totalPage>1"
        :pages="totalPage"
        :groups="totalPage>5?5:totalPage"
        @jump="jumpPage"
      />
    </div> -->
  </div>
</template>

<script>

import api from '../../../../../api/userpage.js'
// import pagination from '@/components/Paginate.vue'
import user from '../../../../../models/user.js'

export default {
  name: 'Collection',
  components: {
    // pagination
  },
  data() {
    return {
      list: null,
      totalPage: 0,
      total: 0,
      mouseOverIndex: -1,
      params: { current: 1, size: 10 },
      loading: false
    }
  },
  created() {
    // this.loading= true
    this.request()
  },
  methods: {
    request() {
      const that = this
      that.loading = true
      api.personcollections(this.params).then(r => {
        that.list = that.prepearData(r.data.records)
        that.loading = false
        that.totalPage = r.data.pages
        that.total = r.data.total
      }).catch(() => {
        that.list = []
        that.loading = false
      })
    },
    prepearData(data) {
      // this.loading = true
      data.forEach(v => {
        var title = v.collectionName
        if (v.subtitle) {
          title = title + '-' + v.subtitle
        }
        if (v.chapter) {
          title = title + '-' + v.chapter
        }
        v.collectionName = title
      })
      return data
    },
    showdelapply(e) {
      const idx = e.currentTarget.dataset.index
      const params = {
        collectionId: this.list[idx].collectionId,
        userId: user.userId
      }
      const that = this
      api.removecollection(params).then(r => {
        that.request()
      }).catch(() => {
        that.$message({
          showClose: false,
          message: '取消收藏失败',
          type: 'error'
        })
      })
    },
    mouseleave() {
      this.mouseOverIndex = -1
    },
    mouseover(e) {
      this.mouseOverIndex = e.currentTarget.dataset.index
    },
    jumpPage(v) {
      this.params.current = v
      this.request()
    },
    toDetail(v) {
      if (v.permissionRange !== 4) {
        const routeData = this.$router.resolve({
          name: 'Resource',
          query: {
            rsId: v.id,
            permission: v.permissionRange
          }
        })
        window.open(routeData.href, '_blank')
      } else {
        const userdata = user.getUserData()
        if (v.user.createUser === userdata.id) {
          const routeData = this.$router.resolve({
            name: 'Resource',
            query: {
              rsId: v.id
            }
          })
          window.open(routeData.href, '_blank')
        }
      }
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>

<style scoped>
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  color: rgb(38, 68, 128);
  font-size: 14px;
  font-weight: 600;
  background-color: rgb(243, 244, 249);
}

::v-deep .el-pager li {
  padding: 0 4px;
  font-size: 14px;
  background-color: transparent !important;
  font-weight: 500;
  color: rgb(38, 68, 128);
  /* height: 28px; */
  line-height: 28px;
  /* box-sizing: border-box; */
  text-align: center;
}

::v-deep .btn-next {
  padding: 0 4px;
  font-size: 14px;
  background-color: transparent !important;
  font-weight: 500;
  color: rgb(38, 68, 128);
  /* height: 28px; */
  line-height: 28px;
  /* box-sizing: border-box; */
  text-align: center;
}

::v-deep .btn-prev {
  padding: 0 4px;
  font-size: 14px;
  background-color: transparent !important;
  font-weight: 500;
  color: rgb(38, 68, 128);
  /* height: 28px; */
  line-height: 28px;
  /* box-sizing: border-box; */
  text-align: center;
}
</style>
<style scoped>

 .body-right-upload-list {
   padding-top: 8px;
 }

 .body-right-upload-list-item-img {
   width: 146px;
   padding-top: 32px;
   margin-right: 26px;
 }

 .body-right-upload-list-item-img .img {
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center;
    width: 146px;
    height: 98px;
  }

 .body-right-upload-list-item-info {
   padding-top: 24px;
 }

 .body-right-upload-list-item-info-tit {
   height: 30px;
   overflow: hidden;
 }

 .body-right-upload-list-item-info-tit p {
   flex-shrink: 0;
 }

 .body-right-upload-list-item-info-desc {
   height: 40px;
 }

 .body-right-upload-list-item-info-mark {
   margin-top: 10px;
 }

 .body-right-upload-list-item-info-mark-item {
   height: 24px;
   padding: 6px 8px;
   margin-right: 10px;
 }

 .body-right-upload-list-item-info-mark-item p {
   margin-right: 2px;
 }
 .body-right-upload-list-item-info-mark-item p:last-child {
   margin: 0;
 }

 .status-success {
   background-color: #F3F4F9;
 }

 .status-success p {
   color: rgba(0, 0, 0, 0.5);
 }

 .status-fail {
   background-color: rgba(205, 46, 46,0.1)
 }

 .status-fail p {
   color: #CD2E2E;
 }

 .status-ing {
   background-color: rgba(211, 160, 48, 0.2)
 }

 .status-ing p {
   color: #D3A030;
 }

 .body-right-upload-list-item-info-mark-del {
   width: 100px;
   height: 24px;
 }

 .body-right-upload-list-item-info-mark-del  p {
   opacity: 0.5;
 }

 .data-pagination {
    height: 100px;
    /* border-top: 1px solid rgba(38, 42, 51, 0.1); */
  }

.empty {
  height: 300px;
}

</style>
